import React from "react";
import {
  LinkRecord,
  LinkRecordAction,
  LinkRecordActionType,
} from "winslow-core";
import { formatDate } from "winslow-core";
import { SquareX } from "lucide-react";
import { getUnifiedIconPath } from "winslow-core";
import "./ResourceActionSingle.css";

interface ResourceActionSingleProps {
  linkRecordActions: LinkRecordAction[];
  linkRecord: LinkRecord | undefined;
  supportedApps: any;
  storeUser: any;
  formatActionType: (actionType: LinkRecordActionType) => string;
}

export const ResourceActionSingle: React.FC<ResourceActionSingleProps> = ({
  linkRecordActions,
  linkRecord,
  supportedApps,
  storeUser,
  formatActionType,
}) => {
  const link = linkRecord?.links?.[0];

  const appLogo = getUnifiedIconPath(
    { 
      appId: link?.appId || "OTHER",
      filename: link?.title || "Removed Resource"
    },
    supportedApps || [],
    { 
      theme: storeUser?.theme || "light-mode",
      forceActivity: true
    }
  );

  return (
    <div className="single-action-messages">
      <div className="single-resource-header-info">
        <div className="single-resource-header-top">
          <div className="single-link-record-activity-logo">
            <img src={appLogo} alt="" />
          </div>
          <div className="single-link-record-activity-title-container">
            <div className="single-link-record-activity-title">
              {link?.title || <em>Removed Resource</em>}
            </div>
            {linkRecord &&
              link &&
              linkRecord.source === "LINK" &&
              (link.appId === "OTHER" || link.appId === "LINK_PDF") && (
                <div className="single-link-record-activity-url-card-url">
                  <a href={link.url} target="_blank" rel="noreferrer noopener">
                    {link.url}
                  </a>
                </div>
              )}
          </div>
        </div>
      </div>
      <hr className="single-action-message-divider" />
      {linkRecordActions.map((action) => (
        <div key={action.id} className="single-action-message">
          <div className="single-action-message-bottom-row">
            <div className="single-action-type-icon">
              {action.actionType === LinkRecordActionType.CONNECTED && (
                <img src="/icons/action-created.svg" alt="" />
              )}
              {action.actionType === LinkRecordActionType.CREATED && (
                <img src="/icons/action-created.svg" alt="" />
              )}
              {action.actionType === LinkRecordActionType.UPDATED && (
                <img src="/icons/action-updated.svg" alt="" />
              )}
              {action.actionType === LinkRecordActionType.DELETED && (
                <img src="/icons/action-deleted.svg" alt="" />
              )}
              {action.actionType === LinkRecordActionType.EMBEDDED && (
                <img src="/icons/action-embedded.svg" alt="" />
              )}
              {action.actionType === LinkRecordActionType.ERRORED && (
                <SquareX style={{ color: "#f61924" }} />
              )}
            </div>

            <span className="single-action-type">
              {formatActionType(action.actionType)}
            </span>
            {action.actorAvatarUrl &&
              action.actorDisplayName !== "System" &&
              action.actorDisplayName && (
                <span className="single-action-actor-avatar">
                  <img
                    src={action.actorAvatarUrl}
                    alt="Actor Avatar"
                    className="single-action-actor-avatar"
                  />
                </span>
              )}
            {action.actorAvatarUrl && action.actorDisplayName === "System" && (
              <span className="single-action-actor-avatar">
                {/* later expand this to support all apps */}
                <img
                  src={"/icons/confluence.svg"}
                  alt="Actor Avatar"
                  className="single-action-actor-avatar"
                />
              </span>
            )}

            {action.actorDisplayName && (
              <span className="single-action-actor-name">
                by {action.actorDisplayName}
              </span>
            )}

            <span className="single-action-date">
              {formatDate(action.createdAt)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
